import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_BLACK } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const Track1BBlack = ({ state, workState, onLabelClick }) => (
	<g id="Track1BBlack" strokeLinecap="round"
		 transform="translate(965.000000, 850.000000)"
		 className="track"
	>
		<g id="line" stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLACK)}
			 strokeWidth={tracksWidth}>
			<path
				d="M28,37 L81.976088,107.533245 C88.5582169,116.134441 96.4939333,123.609221 105.473151,129.665511 L146,157 L146,157"
				strokeWidth={tracksWidth}/>

			<TrackArrow
				points="22 30 14 22 22 14"
				transform="translate(18.000000, 22.000000) scale(-1, 1) rotate(-49.000000) translate(-18.000000, -22.000000) "/>

			<line x1="20" y1="24" x2="0.5" y2="0.5" strokeWidth={tracksWidth}/>
		</g>

		<Label
			coords="46.549348, 66.738515"
			onClick={(event, ref) => onLabelClick(event, ref, 'Track1BBlack')}
			id="label1BBlack"
			text="1B"
			textCoordsX="11.3222656"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLACK)}
		/>
	</g>
);

Track1BBlack.propTypes = trackPropTypes;

export default Track1BBlack;
